import ManageRotatingQuestion from './ManageRotatingQuestion.container';

export default ManageRotatingQuestion;
